module.exports = __webpack_public_path__ + "static/assets/60ad32c07eeb04fa6c3ee68586572329.png";